'use strict';
var PartnerController = /** @class */ (function () {
    /*@ngInject*/
    function PartnerController($scope) {
        $scope.vm.isHeroTabs = false;
    }
    return PartnerController;
}());
export default PartnerController;
//# sourceMappingURL=partners.controller.js.map